import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import AddressSection from "@Shared/components/sections/new-sections/address-section";
import { postSecureAccountsApi } from "@Shared/@Utils/ajax";
import { showToast, STRIPE_API_KEY } from "@Shared/@Utils/constants";
import Err from "@Broker/@Routes/error";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { pick } from "lodash";
import { validCanadianPostalCode } from "@Shared/@Utils/validation-rules";
import { mapActions } from "vuex";
import { LOAD_ACCOUNT_PLAN_DETAILS } from "../../store/account-plan-actions";
import Amplitude from "@Shared/@Utils/amplitude";
import DefaultBodyLoader from "@Shared/components/modals/generic-modal-loaders/default-body-loader.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AddPaymentModal",
  title: "Payments",
  components: {
    GenericModal,
    SimpleButton,
    AddressSection,
    DefaultBodyLoader
  },
  mixins: [validationMixin],
  validations: {
    address: {
      line1: {
        required
      },
      city: {
        required
      },
      province: {
        required
      },
      "postal-code": {
        required,
        validCanadianPostalCode
      }
    }
  },
  data() {
    return {
      loading: false,
      loadingSucceeded: null,
      loadingStripe: false,
      modalOpened: false,
      stripeHandler: null,
      stripeCard: null,
      paymentInfoError: null,
      address: {
        city: "",
        line1: "",
        line2: "",
        "postal-code": "",
        province: "",
        "street-direction": "",
        "street-name": "",
        "street-number": "",
        "unit-number": ""
      }
    };
  },
  computed: {
    addressCustomExpressions() {
      return {
        "street-name": "address.street-name",
        city: "address.city",
        province: "address.province",
        "postal-code": "address.postal-code",
        "unit-number": "address.unit-number",
        "street-number": "address.street-number"
      };
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AccountPlanStore", [LOAD_ACCOUNT_PLAN_DETAILS])), {}, {
    openModal() {
      this.$refs.addPayment.show();
      this.modalOpened = true;
      Amplitude.logEvent("Account Plan - Add Payment Method Modal Opened");
    },
    closeModal() {
      if (this.modalOpened) {
        this.$refs.addPayment.hide();
      }
    },
    resetModal() {
      this.modalOpened = false;
      this.paymentInfoError = null;
      this.address = {
        city: "",
        line1: "",
        line2: "",
        "postal-code": "",
        province: "",
        "street-direction": "",
        "street-name": "",
        "street-number": "",
        "unit-number": ""
      };
      this.$v.$reset();
      Amplitude.logEvent("Account Plan - Add Payment Method Modal Closed");
    },
    addPaymentButtonFinish() {
      if (this.loadingSucceeded) {
        this.closeModal();
      }
    },
    async setupStripe() {
      try {
        this.loadingStripe = true;
        this.stripeHandler = window.Stripe(STRIPE_API_KEY, {
          locale: this.$i18n.locale.substring(0, 2)
        });
        const elementStyles = {
          base: {
            color: "#32325D",
            fontSize: "1rem",
            fontWeight: 400,
            fontFamily: "Leto, monospace",
            fontSmoothing: "antialiased",
            "::placeholder": {
              color: "#CFD7DF"
            },
            ":-webkit-autofill": {
              color: "#000000"
            }
          },
          invalid: {
            color: "#E25950",
            "::placeholder": {
              color: "#cfd7df"
            }
          }
        };
        const elementClasses = {
          focus: "focused",
          empty: "empty",
          invalid: "invalid"
        };
        const elements = this.stripeHandler.elements();
        this.stripeCard = elements.create("cardNumber", {
          style: elementStyles,
          classes: elementClasses
        });
        this.stripeCard.mount("#payment-card-number");
        const cardExpiry = elements.create("cardExpiry", {
          style: elementStyles,
          classes: elementClasses
        });
        cardExpiry.mount("#payment-card-expiry");
        const cardCvc = elements.create("cardCvc", {
          style: elementStyles,
          classes: elementClasses
        });
        cardCvc.mount("#payment-card-cvc");

        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let self = this;
        let savedErrors = {};
        [this.stripeCard, cardExpiry, cardCvc].forEach((element, idx) => {
          element.on("change", event => {
            if (event.error) {
              savedErrors[idx] = event.error.message;
              self.paymentInfoError = event.error.message;
            } else {
              var _context, _context2;
              savedErrors[idx] = null;

              // Loop over the saved errors and find the first one, if any.
              let nextError = _reduceInstanceProperty(_context = _sortInstanceProperty(_context2 = _Object$keys(savedErrors)).call(_context2)).call(_context, (maybeFoundError, key) => {
                return maybeFoundError || savedErrors[key];
              }, null);
              if (nextError) {
                // Now that they've fixed the current error, show another one.
                self.paymentInfoError = nextError;
              } else {
                // The user fixed the last error; no more errors.
                self.paymentInfoError = "";
              }
            }
          });
        });
        await new _Promise(resolve => {
          const elementsToLoad = 3;
          let loadedElements = 0;
          [this.stripeCard, cardExpiry, cardCvc].forEach(element => {
            element.on("ready", () => {
              loadedElements++;
              if (elementsToLoad === loadedElements) resolve();
            });
          });
        });
        this.loadingStripe = false;
        Amplitude.logEvent("Account Plan - Stripe Setup Completed");
      } catch (e) {
        Err.handle(e);
      }
    },
    addPaymentMethod() {
      this.loading = true;
      const billingAddress = {
        address_line1: this.address.line1,
        address_line2: this.address.line2,
        address_city: this.address.city,
        address_state: this.address.province,
        address_zip: this.address["postal-code"]
      };
      this.stripeHandler.createToken(this.stripeCard, billingAddress).then(result => {
        if (result.error) {
          this.paymentInfoError = result.error.message;
          this.loadingSucceeded = false;
          this.loading = false;
        } else if (this.$v.$invalid) {
          this.paymentInfoError = this.$t("payments.messages.addPaymentAddress");
          this.loadingSucceeded = false;
          this.loading = false;
        } else {
          this.stripeTokenHandler(result.token);
        }
      });
    },
    stripeTokenHandler(token) {
      const {
        id
      } = token;
      this.createPaymentMethod({
        id,
        address: pick(this.address, ["city", "line1", "line2", "postal-code", "province"])
      });
    },
    async createPaymentMethod(paymentInformation) {
      try {
        await postSecureAccountsApi(paymentInformation, "/payment");
        showToast("success", "paymentMethodAdded");
        Amplitude.logEvent("Account Plan - Add Payment Method Attempt Completed");
      } catch (e) {
        Err.handle(e);
      } finally {
        this.handleAddPaymentSuccess();
      }
    },
    handleAddPaymentSuccess() {
      this.loadingSucceeded = true;
      this.loading = false;
      this.LOAD_ACCOUNT_PLAN_DETAILS();
    },
    handleAddressChange(val) {
      this.address = val;
      if (!this.$v.$invalid && this.paymentInfoError == this.$t("payments.messages.addPaymentAddress")) {
        this.paymentInfoError = "";
      }
    }
  })
});